import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { Row, Tab, Nav, NavItem, Accordion, Panel } from 'react-bootstrap'
import { ContentFilter, QuickFeedback } from '../../components'
import Isvg from 'react-inlinesvg'
import Parser from 'html-react-parser'
import { OptionsHOC } from '../../hocs'
import { Wrapper } from '../ExpressHelp/ExpressContent'

const proptypes = {
  currentPhone: PropTypes.object,
  location: PropTypes.object.isRequired,
  preSaleFlag: PropTypes.bool.isRequired,
  query: PropTypes.object,
  getOption: PropTypes.func.isRequired
}

const contextTypes = {
  router: PropTypes.object.isRequired
}

let SupportLanding = (
  {
    query,
    createUserEvent,
    landingCategories,
    getOption
  }
) => {
  return (
    <div>
      <Wrapper>
        {Parser(getOption('landing.banner'))}
        <Tab.Container defaultActiveKey="category_0" id="primary-container">
          <div>
            <Row>
              <Nav bsClass="nav nav-pills nav-justified nav-primary">
                <For each="category" index="index" of={landingCategories}>
                  <NavItem
                    eventKey={'category_' + index}
                    key={'primary_' + index}
                    onClick={() => {
                      createUserEvent({
                        category: 'landing',
                        data: {
                          action: 'TogglePrimaryCategory',
                          target: category.name
                        }
                      })
                      category.acadLink &&
                          browserHistory.push({
                            pathname: category.acadLink,
                            query: query
                          })
                    }}
                  >
                    <div className="primary-category-tab">
                      {category.icon && <Isvg src={category.icon}>SVG</Isvg>}
                      <p>{category.name}</p>
                    </div>
                  </NavItem>
                </For>
              </Nav>
            </Row>
            <Row>
              <Tab.Content animation>
                <For each="category" index="index" of={landingCategories}>
                  <Tab.Pane
                    eventKey={'category_' + index}
                    key={'primarypane_' + index}
                  >
                    <Tab.Container
                      defaultActiveKey="subcategory_0"
                      id={'sub-container-' + index}
                    >
                      <div>
                        <Row>
                          <Nav bsClass="nav nav-pills nav-sub">
                            <For
                              each="subcategory"
                              index="subindex"
                              of={category.children}
                            >
                              <NavItem
                                eventKey={'subcategory_' + subindex}
                                key={'sub_' + subindex}
                                onClick={() =>
                                  createUserEvent({
                                    category: 'landing',
                                    data: {
                                      action: 'ToggleSecondaryCategory',
                                      target: subcategory.name
                                    }
                                  })
                                }
                              >
                                <div className="sub-category-tab">
                                  {subcategory.name}
                                </div>
                              </NavItem>
                            </For>
                          </Nav>
                        </Row>
                        <Row>
                          <Tab.Content animation>
                            <For
                              each="subcategory"
                              index="subindex"
                              of={category.children}
                            >
                              <Tab.Pane
                                eventKey={'subcategory_' + subindex}
                                key={'subpane_' + subindex}
                              >
                                <Accordion bsClass="panel-group faq-list">
                                  <For
                                    each="faq"
                                    index="faqindex"
                                    of={subcategory.children}
                                  >
                                    <Panel
                                      header={faq.name}
                                      eventKey={'faq_' + faqindex}
                                      key={'subfaq_' + faqindex}
                                      onEnter={() =>
                                        createUserEvent({
                                          category: 'landing',
                                          data: {
                                            action: 'ToggleSingleFAQ',
                                            target: faq.pk
                                          }
                                        })
                                      }
                                    >
                                      <ContentFilter text={faq.val} />
                                      <QuickFeedback
                                        type="landing"
                                        faqId={faq.pk}
                                        createUserEvent={createUserEvent}
                                      />
                                    </Panel>
                                  </For>
                                </Accordion>
                              </Tab.Pane>
                            </For>
                          </Tab.Content>
                        </Row>
                      </div>
                    </Tab.Container>
                  </Tab.Pane>
                </For>
              </Tab.Content>
            </Row>
          </div>
        </Tab.Container>
      </Wrapper>
    </div>
  )
}


SupportLanding.contextTypes = contextTypes
SupportLanding.propTypes = proptypes

export default LanguageProvider(OptionsHOC(SupportLanding))



// WEBPACK FOOTER //
// ./src/components/SupportLanding/SupportLanding.js